import { Link } from "react-router-dom"
import "./AboutContentStyles.css"
import react1 from "../assests/react1.jpg"
import react2 from "../assests/react2.jpg"

import React from 'react'

const AboutContent = () => {
  return (
    <div className="about">
        <div className="left">
            <h1>Why Me ?</h1>
            <p>Im a react front-end developer, I create responsive secure websites for my clients.<br/><br/>
                Let's collaborate to create impactful web applications together.</p>
            <Link to="/contact">
                <button className="btn">Contact</button>
            </Link>
        </div>
        <div className="right">
            <div className="img-container">
                <div className="img-stack top">
                    <img src={react1} className="img" alt="true"/>
                </div>
                <div className="img-stack bottom">
                    <img src={react2} className="img" alt="true"/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default AboutContent